import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import PhaseType from 'types/phase';

export const appointment_deleted = ({ event: { kind, data } }) => {
  const { appointment_type, appointment_date, who, cancelled } = data;
  const date = moment(appointment_date).local().format('MM/DD/YYYY');
  const apptType = appointment_type === 'Repair Inspection' ? 'Workorder Inspection' : appointment_type;
  const name = `${apptType} appointment`;
  const cMsg = `${name} scheduled for ${date} was deleted because the phase was cancelled`;
  const oMsg = `${who} requested to delete the ${name} scheduled for ${date}`;
  return (<div className={kind}>{(cancelled && cMsg) || oMsg}</div>);
};

appointment_deleted.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      appointment_type: PropTypes.string.isRequired,
      appointment_date: PropTypes.string.isRequired,
      who: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_deleted.jsx